import { usePrimeVue } from 'primevue/config';

const layoutConfig = reactive({
  preset: 'Aura',
  primary: 'emerald',
  surface: null,
  darkTheme: false,
  menuMode: 'static'
});

const layoutState = reactive({
  staticMenuDesktopInactive: false,
  overlayMenuActive: false,
  profileSidebarVisible: false,
  configSidebarVisible: false,
  staticMenuMobileActive: false,
  menuHoverActive: false,
  activeMenuItem: null
});


export function useLayout() {
  const {public: config} = useRuntimeConfig();
  const isDarkMode = useState('layout:darkmode',()=>false);
  const PrimeVue = usePrimeVue();
  
  const setPrimary = (value: any) => {
    layoutConfig.primary = value;
  };

  const setSurface = (value: any) => {
    layoutConfig.surface = value;
  };

  const setPreset = (value: any) => {
    layoutConfig.preset = value;
  };

  const setActiveMenuItem = (item) => {
    layoutState.activeMenuItem = item.value || item;
  };

  const setMenuMode = (mode) => {
    layoutConfig.menuMode = mode;
  };

  const toggleDarkMode = () => {
    isDarkMode.value = !isDarkMode.value;
    executeDarkModeToggle();
  };

  const executeDarkModeToggle = () => {
    const themeLink: HTMLLinkElement = document.getElementById('theme-link') as HTMLLinkElement;
    if(themeLink){
      themeLink.href = isDarkMode.value ? config.darkTheme : config.lightTheme;
      localStorage.setItem('layout:darktheme',isDarkMode.value.toString());

      const element = document.querySelector('html');
      if(element && isDarkMode.value){
        element.classList.add('app-dark');
      }
    }
  };

  const onMenuToggle = () => {
    if (layoutConfig.menuMode === 'overlay') {
      layoutState.overlayMenuActive = !layoutState.overlayMenuActive;
    }

    if (window.innerWidth > 991) {
      layoutState.staticMenuDesktopInactive = !layoutState.staticMenuDesktopInactive;
    } else {
      layoutState.staticMenuMobileActive = !layoutState.staticMenuMobileActive;
    }
  };

  const resetMenu = () => {
    layoutState.overlayMenuActive = false;
    layoutState.staticMenuMobileActive = false;
    layoutState.menuHoverActive = false;
  };

  const isSidebarActive = computed(() => layoutState.overlayMenuActive || layoutState.staticMenuMobileActive);

  const isDarkTheme = computed(() => layoutConfig.darkTheme);

  const getPrimary = computed(() => layoutConfig.primary);

  const getSurface = computed(() => layoutConfig.surface);

  onMounted(() => {
    
  });

  return { layoutConfig: readonly(layoutConfig), layoutState: readonly(layoutState), onMenuToggle, isSidebarActive, isDarkMode, getPrimary, getSurface, setActiveMenuItem, toggleDarkMode, setPrimary, setSurface, setPreset, resetMenu, setMenuMode };
}
